import PropTypes from 'prop-types';
import { memo, useState } from 'react';
import { FaStar } from 'react-icons/fa';

const pageSize = 5;

const ReviewsDetails = ({ product }) => {
  const reviews = product.reviews || [];
  const [shownCount, setShownCount] = useState(pageSize);

  return (
    <div className="text-sm">
      {reviews.slice(0, shownCount).map((review) => (
        <div key={`${review.date}-${review.text}`} className="border-b py-3">
          <div className="flex items-center mb-1">
            {[0, 1, 2, 3, 4].map((index) => (
              <FaStar
                key={index}
                size="13"
                className={index < Math.round(review.rating || 0) ? 'text-theme' : 'text-gray-300'}
              />
            ))}
            <span className="text-gray-500 ml-2">{review.date}</span>
          </div>
          <div className="text-gray-700">{review.text}</div>
        </div>
      ))}

      {shownCount < reviews.length && (
        <button
          type="button"
          className="text-theme mt-3 focus:outline-none"
          onClick={() => setShownCount((count) => count + pageSize)}
        >
          Show more reviews
        </button>
      )}
    </div>
  );
};

ReviewsDetails.propTypes = {
  product: PropTypes.shape().isRequired,
};

export default memo(ReviewsDetails);
